import { render, staticRenderFns } from "./OrderHelp.vue?vue&type=template&id=d2d9f46a&scoped=true&"
import script from "./OrderHelp.vue?vue&type=script&lang=js&"
export * from "./OrderHelp.vue?vue&type=script&lang=js&"
import style0 from "./OrderHelp.vue?vue&type=style&index=0&id=d2d9f46a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d9f46a",
  null
  
)

export default component.exports